import { useAppActions } from 'reducers/slices/quizSlice';
import { useSelector } from 'react-redux';

export default () => {
  const {
    submitCurrentStep,
    changeValue,
    setCurrentQuestionValidity,
    setManuallyChangedField,
    discardQuiz,
    setFinishQuiz,
    setRegistrationModalOpen,
  } = useAppActions();
  const {
    lastQuestionId,
    quizValues,
    isCurrentQuestionValid,
    manuallyChangedFields,
    quizFinished,
    registrationModalOpen,
  } = useSelector(state => state.quizSlice);

  return {
    submitCurrentStep,
    quizFinished,
    setFinishQuiz,
    setRegistrationModalOpen,
    registrationModalOpen,
    discardQuiz,
    setManuallyChangedField,
    manuallyChangedFields,
    setCurrentQuestionValidity,
    changeValue,
    lastQuestionId,
    quizValues,
    isCurrentQuestionValid,
  };
};



// WEBPACK FOOTER //
// ./src/reducers/hooks/useQuiz.js